module.exports = __webpack_public_path__ + "static/media/toshiba-social-feeds_nexus.8dcdd7f2.jpg";